import { inject as mobxInject } from 'mobx-react';
import { StoreKey } from '../stores';

/**
 * Wraps the mobx react inject function to allow undefined injected stores when the component
 * is not implemented within a provider that provides the store
 *
 * @param names of the stores to inject
 * @returns mobx react inject function
 */
export function inject(...names: Array<StoreKey>) {
    return mobxInject((stores, props, context) => {
        for (const name of names) {
            // default store to empty if not defined
            stores[name] = stores[name] || null;
            // assign store to props so that component can access it
            if (props[name] === undefined) {
                props[name] = stores[name];
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/inject.ts